import { render, staticRenderFns } from "./CustomerActions.vue?vue&type=template&id=baa892ce"
import script from "./CustomerActions.vue?vue&type=script&lang=js"
export * from "./CustomerActions.vue?vue&type=script&lang=js"
import style0 from "./CustomerActions.vue?vue&type=style&index=0&id=baa892ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports